import { useQuery } from '@tanstack/react-query';

import ParityNotificationsService from '~/services/ParityNotificationsService';

import { parityNotificationQueryKeys } from './parityNotificationQueryKeys';

export function useGetUnsolvedParityNotifications() {
  return useQuery({
    queryKey: parityNotificationQueryKeys.unsolvedParity(),
    queryFn: () => ParityNotificationsService.getUnsolvedParityNotifications(),
  });
}
